import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/charge_points',
  component: Management,
  redirect: '/charge_points/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/charge_points/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listChargePoints
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/charge_points/ListTable'),
          meta: {
            auth: Auth.listChargePoints,
            tabName: 'all'
          }
        },
        {
          path: 'dc',
          component: () => import('@/views/charge_points/ListTable'),
          meta: {
            auth: Auth.listChargePoints,
            tabName: 'dc'
          }
        },
        {
          path: 'ac',
          component: () => import('@/views/charge_points/ListTable'),
          meta: {
            auth: Auth.listChargePoints,
            tabName: 'ac'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/charge_points/New'),
      meta: {
        auth: Auth.createChargePoint
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/charge_points/Edit'),
      meta: {
        auth: Auth.updateChargePoint
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/charge_points/DetailLayout'),
      meta: {
        auth: Auth.showChargePoint
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/charge_points/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargePoint
          }
        },
        // 费率
        {
          path: 'billing_rules',
          component: () => import('@/views/charge_points/details/BillingRules'),
          meta: {
            tabName: 'billing_rules', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargePoint
          }
        }
      ]
    }
  ]
}
